import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import moment from "moment";
import {
	useTable,
	usePagination,
	useSortBy,
	useExpanded,
	useGlobalFilter,
	useRowSelect,
} from "react-table";
// import MainTablePagination from "./MainTablePagination";
import { PORTWISE_CONTAINER_REPORT_COLUMN } from "../../columns/CommonColumns";
import { getAllModuleReportData } from "../../../services/dataService";
import { uniqBy, filter, sumBy } from "lodash";
import { exportData } from "../../../utils/helpers";
import "./PortwiseContainerReport.css";
import Tooltips from "../../Custom Components/tooltip";
import MainTablePaginationAdv from "./MainTablePaginationAdv";
import noDataAvailable from "../../../assets/img/noDataAvailable.png";
import { PulseLoader } from "react-spinners";

function PortwiseContainerReport({ filteredUserAccessData, type }) {
	const [date, setDate] = useState({
		fromDate: moment().format("YYYY-MM-DD"),
		toDate: moment().add(1, "days").format("YYYY-MM-DD"),
	});
	const [columns] = useState(PORTWISE_CONTAINER_REPORT_COLUMN);
	const [tableData, setTableData] = useState([]);
	const [noDataState, setNoDataState] = useState(false);
	const [loading, setLoading] = useState(false);

	var allowToDownload =
		filter(filteredUserAccessData, { DownLoad: 1 }).length > 0;

	useEffect(() => {
    var newPortForTractor = [];
    var newPortForAggregate = [];
    var newPortFor5M = [];
    var newDataOfTractor = [];
    var newDataOfAggregate = [];
    var newDataOf5M = [];
    var newContainerCount = [];
    var dataArray = [];
    async function getAllShipmentList() {
      if (type === "Port") {
        try {
          setLoading(true);
          setNoDataState(false);
          const response = await getAllModuleReportData(date);

          const tractorFilter = filter(response.data, { DataOf: "TRACTOR" });
          const aggregateFilter = filter(response.data, {
            DataOf: "AGGREGATE",
          });
          const five_M_Filter = filter(response.data, { DataOf: "5M" });

          const uniqPortForTractor = uniqBy(
            tractorFilter,
            "Port_Of_Destination"
          );
          const uniqPortForAggregate = uniqBy(
            aggregateFilter,
            "Port_Of_Destination"
          );
          const uniqPortFor5M = uniqBy(five_M_Filter, "Port_Of_Destination");

          for (let i = 0; i < uniqPortForTractor.length; i++) {
            newPortForTractor.push(uniqPortForTractor[i].Port_Of_Destination);
            newDataOfTractor.push(uniqPortForTractor[i].DataOf);
          }
          for (let i = 0; i < uniqPortForAggregate.length; i++) {
            newPortForAggregate.push(
              uniqPortForAggregate[i].Port_Of_Destination
            );
            newDataOfAggregate.push(uniqPortForAggregate[i].DataOf);
          }
          for (let i = 0; i < uniqPortFor5M.length; i++) {
            newPortFor5M.push(uniqPortFor5M[i].Port_Of_Destination);
            newDataOf5M.push(uniqPortFor5M[i].DataOf);
          }

          for (let j = 0; j < newPortForTractor.length; j++) {
            const filteredPort = filter(tractorFilter, {
              Port_Of_Destination: newPortForTractor[j],
            });
            const containerCountSummation = sumBy(
              filteredPort,
              function (item) {
                return item.Container_Count;
              }
            );
            newContainerCount.push(containerCountSummation);
          }
          for (let j = 0; j < newPortForAggregate.length; j++) {
            const filteredPort = filter(aggregateFilter, {
              Port_Of_Destination: newPortForAggregate[j],
            });
            const containerCountSummation = sumBy(
              filteredPort,
              function (item) {
                return item.Container_Count;
              }
            );
            newContainerCount.push(containerCountSummation);
          }
          for (let j = 0; j < newPortFor5M.length; j++) {
            const filteredPort = filter(five_M_Filter, {
              Port_Of_Destination: newPortFor5M[j],
            });
            const containerCountSummation = sumBy(
              filteredPort,
              function (item) {
                return item.Container_Count;
              }
            );
            newContainerCount.push(containerCountSummation);
          }
          var concatNewPort = [].concat(
            newPortForTractor,
            newPortForAggregate,
            newPortFor5M
          );
          var concatNewDataOf = [].concat(
            newDataOfTractor,
            newDataOfAggregate,
            newDataOf5M
          );
          for (let k = 0; k < concatNewPort.length; k++) {
            if (concatNewPort[k]) {
              const tableRow = {
                DataOf: concatNewDataOf[k],
                Port_Of_Destination: concatNewPort[k],
                Container_Count: newContainerCount[k],
              };

              dataArray.push(tableRow);
            }
          }
          setTableData(dataArray);
          setLoading(false);
        } catch (error) {
          setTableData([]);
          if (error.response.data.StatusCode === 404) {
            setNoDataState(true);
          }
          setLoading(false);
        }
      }
    }
    getAllShipmentList();
  }, [date, type]);

	useEffect(() => {
		if (moment(date.fromDate).isAfter(date.toDate)) {
			alert("From date should not be after of To date");
		}
	}, [date]);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		nextPage,
		previousPage,
		canNextPage,
		pageOptions,
		pageCount,
		gotoPage,
		state,
		setPageSize,
		canPreviousPage,
		setGlobalFilter,
		prepareRow,
	} = useTable(
		{
			columns,
			data: tableData,
			autoResetPage: false,
			initialState: { pageSize: 50 },
			autoResetExpanded: false,
			autoResetGlobalFilter: false,
		},
		useGlobalFilter,
		useSortBy,
		useExpanded,
		usePagination,
		useRowSelect
	);

	const { pageIndex, pageSize, globalFilter } = state;

	function downloadHandler() {
		exportData(
			tableData.map((item) => {
				return {
					MODULE_NAME: item["DataOf"],
					PORT_NAME: item["Port_Of_Destination"],
					CONTAINER_COUNT: item["Container_Count"],
				};
			}),
			`Portwise Container Report - from-${date.fromDate} to-${date.toDate}`
		);
	}

	return (
		<>
			{loading && (
				<PulseLoader
					color="#007bff"
					size="20px"
					margin="10px"
					style={{ position: "absolute", top: "50vh", left: "45%" }}
				/>
			)}
			{noDataState && (
				<img
					src={noDataAvailable}
					alt="notAvailableImg"
					// width="630px"
					// height="630px"
					className="noDataFoundImg"
					// style={{marginLeft:"-2%"}}
				/>
			)}
			<div
				style={{
					display: "flex",
					flexWrap: "wrap",
					marginBottom: "-35px",
					position: "absolute",
					top: "80px",
					float: "right",
					width: "620px",
					right: "20px",
				}}
				className="res-table"
			>
				<div
					style={{
						display: "flex",
						justifyContent: "space-around",
						marginLeft: "0",
						width: "100%",
					}}
				>
					<div style={{ float: "left" }}>
						<Form.Control
							value={globalFilter || ""}
							onChange={(e) => setGlobalFilter(e.target.value)}
							className="portwise_report_search"
							placeholder="search here.."
						/>
					</div>
					<div
						style={{
							display: "flex",
							width: "200px",
							alignItems: "center",
							fontWeight: "500",
						}}
					>
						<div>From-</div>
						<Form.Control
							type="date"
							// className="portwise_report_fromDate"
							value={date.fromDate}
							onChange={(e) => {
								if(e.target.value <= date.toDate){
									setDate({ ...date, fromDate: e.target.value })
								}else{
									setDate({ ...date, fromDate: date.fromDate })
									alert('From date should not greater than To date.')
								}
							}}
							name="fromDate"
						/>
					</div>
					<div
						style={{
							display: "flex",
							width: "200px",
							alignItems: "center",
							fontWeight: "500",
						}}
					>
						<div>To-</div>
						<Form.Control
							type="date"
							// className="portwise_report_toDate"
							value={date.toDate}
							onChange={(e) => {
								if(e.target.value >= date.fromDate){
									setDate({ ...date, toDate: e.target.value })
								}else{
									setDate({ ...date, toDate: date.toDate })
									alert('To date should not lesser than From date.')
								}
							}}
							name="toDate"
						/>
					</div>
					{allowToDownload && (
						<Tooltips content={"Download"} direction="down">
							<button
								className="portwiseReport__download"
								onClick={downloadHandler}
							>
								<i
									class="bx bxs-download"
									style={{ transform: "scale(1.5)" }}
								></i>
							</button>
						</Tooltips>
					)}
				</div>
			</div>

			{!noDataState && (
				<>
					<div className="table_container__containerReport_Port">
						<table {...getTableProps()} className="tables mtbs">
							<thead>
								{headerGroups.map((headerGroup) => (
									<tr {...headerGroup.getHeaderGroupProps()}>
										{headerGroup.headers.map((column) => (
											<th
												{...column.getHeaderProps(
													column.getSortByToggleProps()
												)}
												className="portwise_report_thead_th"
											>
												{column.render("Header")}
												<i
													className={
														column.isSorted
															? column.isSortedDesc
																? "fi fi-rr-angle-small-down head-icon"
																: "fi fi-rr-angle-small-up head-icon"
															: "fi fi-rr-circle-small head-icon w"
													}
												></i>
											</th>
										))}
									</tr>
								))}
							</thead>
							<tbody {...getTableBodyProps()}>
								{page.map((row) => {
									prepareRow(row);
									return (
										<tr {...row.getRowProps()}>
											{row.cells.map((cell) => {
												return (
													<td
														{...cell.getCellProps()}
														className={
															cell.row.subRows.length !== 0
																? "main-row portwise_report_tbody_td"
																: "sub-row portwise_report_tbody_td"
														}
														// style={{textAlign:"center"}}
													>
														<div className="cell-wrap">
															{cell.render("Cell")}
														</div>
													</td>
												);
											})}
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
					{/* <MainTablePagination
        nextPage={nextPage}
        previousPage={previousPage}
        canNextPage={canNextPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canPreviousPage={canPreviousPage}
        setPageSize={setPageSize}
      /> */}
					<MainTablePaginationAdv
						nextPage={nextPage}
						previousPage={previousPage}
						canNextPage={canNextPage}
						pageIndex={pageIndex}
						pageOptions={pageOptions}
						pageSize={pageSize}
						canPreviousPage={canPreviousPage}
						setPageSize={setPageSize}
						gotoPage={gotoPage}
						pageCount={pageCount}
					/>
				</>
			)}
		</>
	);
}
export default PortwiseContainerReport;
